<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <div :id="idChart"></div>
      </v-col>
      <v-col cols="12">
        <v-slider
          v-model="sizeList"
          :min="20"
          :max="max"
          :label="label"
          step="20"
          dark
          :thumb-size="24"
          thumb-color="#95A1EC"
          track-color="grey"
          track-fill-color="white"
          ticks="always"
          tick-size="10"
          thumb-label
          class="align-center"
          @change="changeChartQtdItems($event)"
        >
          <template v-slot:append>
            <span class="mt-n5">{{ sizeList }}</span>
          </template>
        </v-slider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/export-data';
import Accessibility from 'highcharts/modules/accessibility';
Accessibility(Highcharts);
Exporting(Highcharts);
export default {
  name: 'DBOuseLandTotalChart',
  props: ['cargas', 'sia'],
  data: () => ({
    chartRendered: undefined,
    idChart: 'containerDBOuseLandTotalChart',
    sizeList: 211,
    max: 211,
    label: 'N° de SIAs 211/211',
  }),
  watch: {
    sizeList() {
      this.chartPreprocessing();
      this.label =
        'N° de SIAs ' + String(this.sizeList) + '/' + this.cargas.length;
    },
    sia(value) {
      if (value) {
        this.chartPreprocessing();
        this.sizeList = this.cargas.length;
        this.label =
          'N° de SIAs ' + String(this.sizeList) + '/' + this.cargas.length;
      }
    },
    cargas(value) {
      if (value) {
        this.max = this.cargas.length;
      }
    },
  },
  methods: {
    mapColor(name) {
      const groupColor = [
        {text: 'Floresta', color: '#497000'},
        {text: 'Silvicultura', color: '#A5F900'},
        {text: "Água ou Espelho d'água", color: '#273FB6'},
        {text: 'Pastagem', color: '#FEFD00'},
        {text: 'Agricultura Anual (Soja, milho e trigo)', color: '#EB5757'},
        {text: 'Área Alagada e Área Pantanosa', color: '#43704C'},
        {text: 'Agricultura Perene e Semi-perene', color: '#CE9E00'},
        {text: 'Mangue', color: '#C7FA72'},
        {text: 'Mancha Urbanizada', color: '#8C2202'},
      ];
      const finded = groupColor.find((item) => item.text === name);
      return finded.color;
    },
    changeChartQtdItems(value) {
      this.chartRendered.update({
        chart: {
          scrollablePlotArea: {
            minWidth: value * 40,
            scrollPositionX: 1,
          },
        },
      });
    },
    fillSeries(series, cargas) {
      for (const item in cargas) {
        series[series.length - 1].data.push(cargas[item].cargaValor);
        for (const subItem in cargas[item].tipoValores) {
          const finded = series.find(
            (key) => key.name === subItem,
          );
          finded.data.push(cargas[item].tipoValores[subItem]);
        }
      }
      return series;
    },
    assembleSeries(series) {
      const pattern = this.cargas[0]?.tipoValores;
      for (const item in pattern) {
        series.push({
          name: item,
          data: [],
          type: 'column',
          color: this.mapColor(item),
          yAxis: 0,
        });
      }
      series.push({
        name: 'carga DBO',
        data: [],
        type: 'line',
        lineWidth: 4,
        color: '#FFF',
        yAxis: 1,
        marker: {enabled: false, radius: undefined},
      });
      return series;
    },
    chartPreprocessing() {
      const elementId = this.idChart;
      let chart = document.getElementById(elementId);
      let series = [];
      series = this.assembleSeries(series);
      series = this.fillSeries(series, this.cargas);
      const categories = this.cargas?.map((item) => item.siaId); //item.sia item.siaId
      if (this.sizeList != this.cargas.length) {
        series = series.map((item) => {
          return {...item, data: item.data.slice(0, this.sizeList)};
        });
      }
      if (series) {
        this.charts(elementId, series, categories);
        chart.style.visibility = 'visible';
        chart.style.display = 'block';
      } else {
        chart.style.visibility = 'hidden';
        chart.style.display = 'none';
      }
    },
    async charts(elementId, series, categories) {
      let key;
      if (this.sia) {
        key = String(
          this.sia?.locacronymn?.slice(4, this.sia?.locacronymn?.length),
        );
      }
      const fountains = await this.$store.getters.fountains;
      this.chartRendered = Highcharts.chart(elementId, {
        chart: {
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          scrollablePlotArea: {
            // 40 seria um valor aceitavel pra largura de cada coluna da tabela
            // multiplicado pela quantidade de items dos dados
            minWidth: categories.length * 40,
          },
        },
        title: {text: null},
        subtitle: {text: null},
        exporting: {
          enabled: false,
          sourceWidth: this.sizeList * 40,
          chartOptions: {
            title: {
              text: "Carga Difusa DBO",
              style:{
                color: "#ffffff",
                fontFamily: 'Roboto',
                fontWeight: 700,
                fontSize: '1.1rem',
                lineHeight: '33px',
              },
            },
            subtitle: {
              text: "Uso do solo total",
              style:{
                color: "#ffffff",
                fontFamily: 'Roboto',
                fontWeight: 600,
                fontSize: '0.75rem',
                lineHeight: '24px',
              },
            },
          }
        },
        credits: {enabled: false},
        legend: {
          enabled: true,
          itemStyle: {
            color: '#FFF',
          },
          itemHoverStyle: {
            color: '#979797',
          },
        },
        xAxis: {
          labels: {
            enabled: true,
            style: {
              color: '#FFF',
            },
            rotation: 0,
            useHTML: true,
            formatter: function () {
              if (key === this.value) {
                return `<strong style="clip-path: polygon(50% 0%, 100% 38%, 100% 100%, 0 100%, 0% 38%); background: #3643BE; padding: 8px; border-radius: 50%"> ${this.value} </strong>`;
              }
              return `<span> ${this.value} </span>`;
            },
          },
          categories: categories,
        },
        yAxis: [
          {
            min: 0,
            max: 100,
            opposite: false,
            reversed: false,
            labels: {
              format: '{value}' + '%',
              style: {
                color: '#FFF',
              },
            },
            title: {
              text: 'Porcentagem de uso',
              style: {
                color: '#FFF',
              },
            },
          },
          {
            min: 0,
            max: series[series.length - 1]?.data[0],
            offset: 0,
            opposite: true,
            reversed: false,
            labels: {
              format: '{value}',
              style: {
                color: '#FFF',
              },
            },
            title: {
              text: 'Carga (kg/dia)',
              style: {
                color: '#FFF',
              },
            },
          },
        ],
        tooltip: {
          outside: false,
          enabled: true,
          useHTML: true,
          backgroundColor: '#212a35',
          borderWidth: 0,
          headerFormat: '',
          formatter: function () {
            function round(x) {
              return Math.round((x * 100) / 100);
            }
            function mapIdToName(id) {
              const key = 'SIA - ' + id + ' - ';
              for (const item in fountains) {
                if (fountains[item].locationname.includes(key)) {
                  return fountains[item].locationname;
                }
              }
            }
            function formatNumber(number) {
              return new Intl.NumberFormat("pt-BR").format(number);
            }
            let ranking = categories.indexOf(this.x);
            ranking = ranking + 1;
            return this.points.reduce(function (s, point) {
              if (point.percentage < 100) {
                return (
                  '<span style="color: #FFF">' +
                  s +
                  '</span>' +
                  '<br/>' +
                  '<span style="color:' +
                  point.series.color +
                  '; font-size: 16px">● </span>' +
                  '<span style="color: #FFF;">' +
                  point.series.name +
                  ': ' +
                  '</span>' +
                  '<b style="color: #FFF;">' +
                  round(point.percentage) +
                  '%' +
                  '</b>'
                );
              } else {
                return (
                  '<span style="color: #FFF;">' +
                  s +
                  '</span>' +
                  '<br/>' +
                  '<span style="color:' +
                  point.series.color +
                  '; font-size: 16px; margin-left: 255px;">╸ </span>' +
                  '<span style="color: #FFF;">' +
                  point.series.name +
                  ': ' +
                  '</span>' +
                  '<b style="color:' +
                  point.series.color +
                  '; font-size: 36px;">' +
                  formatNumber(point.y.toFixed(1)) +
                  '</b>' +
                  '<span style="color:' +
                  point.series.color +
                  '; font-size: 16px;">' +
                  ' kg/dia' +
                  '</span>'
                );
              }
            }, '<b style="text-transform: capitalize;">' +
              mapIdToName(this.x) +
              '</b>' +
              '<br/>' +
              '<span style="color: #FFF; font-size: 16px">' +
              'Poluente:' +
              '</span>' +
              '<strong style="color: #FFF; font-size: 25px;">' +
              ' #' +
              ranking +
              '</strong>' +
              '<br/>');
          },
          shared: true,
          crosshairs: true,
        },
        plotOptions: {
          column: {
            stacking: 'percent',
            pointWidth: 18,
            pointPadding: 0.3,
            groupPadding: 0.5,
            events: {
              legendItemClick: function () {
                return false;
              },
            },
          },
          series: {
            stacking: 'normal',
            states: {
              inactive: {
                enabled: false,
              },
            },
          },
        },
        series: series,
      });
      setTimeout(() => {
        this.chartRendered?.series[0]?.points?.forEach((point) => {
          if (point.category === key) {
            point.onMouseOver();
          }
        });
      }, 1000);
      this.$emit('chartRenderComplete', this.chartRendered);
    },
  },
};
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
  width: 4px !important;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /*padding-right-right: 1200px;*/
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
